import { render } from "./NormalWithdraw.vue?vue&type=template&id=2ec94409&scoped=true"
import script from "./NormalWithdraw.vue?vue&type=script&lang=js"
export * from "./NormalWithdraw.vue?vue&type=script&lang=js"

import "./NormalWithdraw.vue?vue&type=style&index=0&id=2ec94409&lang=less&scoped=true"
import "./NormalWithdraw.vue?vue&type=style&index=1&id=2ec94409&lang=less"

import exportComponent from "/home/data/jenkins/workspace/Pro_TWI_T/Pro_TWI_h5_advantrade-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec94409"]])

export default __exports__